interface Model {
  name: string;
  context: string;
  platform: string;
  inputPrice: string;
  outputPrice: string;
}

interface ProviderModelsProps {
  models: Model[];
}

export default function ProviderModels({ models }: ProviderModelsProps) {
  return (
    <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {models.map((model) => (
        <div
          key={model.name}
          className="relative rounded-lg border border-gray-200 bg-white p-6 shadow-sm hover:shadow-md transition-shadow"
        >
          <h3 className="text-lg font-semibold text-gray-900">{model.name}</h3>
          <dl className="mt-4 space-y-2">
            {/* Context Length */}
            <div>
              <dt className="text-sm font-medium text-gray-500">Context Length</dt>
              <dd className="text-sm text-gray-900">{model.context}</dd>
            </div>

            {/* Platform Prices */}
            <div>
              <dt className="text-sm font-medium text-gray-500">{model.platform} Price</dt>
              <dd className="mt-1 text-sm text-gray-900">
                <span className="font-medium">input: </span> ${model.inputPrice} / 1M tokens
              </dd>
              <dd className="text-sm text-gray-900">
                <span className="font-medium">output: </span> ${model.outputPrice} / 1M tokens
              </dd>
            </div>
          </dl>
        </div>
      ))}
    </div>
  );
}

